import { Box, LinearProgress } from '@color/continuum';

export const FixedLoadingIndicator = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
      }}
    >
      <LinearProgress variant="indeterminate" />
    </Box>
  );
};
